<template>
    <v-container class="row-padding" grid-list-xl fluid>
        <v-expansion-panels focusable hover inset>
            <!--SUBACT DETAILS-->
            <v-expansion-panel class="mb-2">
                <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                    <v-toolbar class="expand-panel-header-custom" dense dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>

                        <v-toolbar-title>Datos del subacto</v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-btn icon>
                            <v-icon>mdi-information</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="filter-color pt-4">

                    <v-card id="info-card" class="item-card mx-auto pa-5" raised elevation="100">

                        <loading-wheel v-if="subact_loading"></loading-wheel>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="!subact_loading" class="pa-5" grid-list-xl fluid>
                                <v-row no-gutters>
                                    <v-col cols="auto">
                                        <v-text-field label="Código" color="#da8d2b" style="max-width:90px"
                                            :value="subact['cod']" hide-details="true" type="label" readonly fill>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="subact" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:80px" label="Orden"
                                                color="#da8d2b" :value="subact['order']" hide-details="true"
                                                type="label" readonly fill>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:250px" label="Tipo"
                                                color="#da8d2b"
                                                :value="subact['subact_type']['key'] + ' - ' + subact['subact_type']['name']"
                                                hide-details="true" type="label" readonly fill>
                                            </v-text-field>
                                        </v-row>
                                        <v-row no-gutters justify="start" align="center">
                                            <v-text-field class="my-3 mr-10" style="max-width:105px" label="Inicio"
                                                color="#da8d2b" :value="subact['start']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-start-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de inicio del subacto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-10" style="max-width:95px" label="Finalización"
                                                color="#da8d2b" :value="subact['end']" hide-details="true" type="label"
                                                readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-ray-end-arrow</v-icon>
                                                        </template>
                                                        "Tiempo de finalización del subacto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                            <v-text-field class="my-3 mr-5" style="max-width:100px" label="Duración"
                                                color="#da8d2b" v-model="subact['duration']" hide-details="true"
                                                type="label" readonly fill>
                                                <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-icon dense v-on="on">mdi-clock</v-icon>
                                                        </template>
                                                        "Tiempo de duración del subacto."
                                                    </v-tooltip>
                                                </template>
                                            </v-text-field>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                        <v-card outlined class="filter-row-color my-3">
                            <v-container v-if="subact" class="pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-row no-gutters justify="start" align="center" height="300">
                                            <v-textarea label="Contenido" color="#da8d2b"
                                                :value="subact['metadata_contents']" hide-details="true" auto-grow
                                                readonly fill></v-textarea>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card class="discursive-units-card">
            <v-card-title class="discursive-units-card-title">
                Exploración por unidades discursivas
            </v-card-title>
            <v-expansion-panels focusable hover inset>
                <!--SUBACTS-->
                <v-expansion-panel v-if="subacts.length > 0" class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Subactos</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-hexagon</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">
                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="subacts" :expanded.sync="expanded"
                                            @item-expanded="loadSubactDetails" @update="alert('')" locale="es-ES"
                                            :search="search_subacts" :custom-filter="searchFilter"
                                            :loading="subacts_loading" loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Subactos por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_subacts"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["cod"]}}
                                                                                        </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-center"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container v-if="subact" class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="start" align="center">
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_subact_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('token_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('token_details',
                                                                            item['cod'])" -->
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>

                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <!--TOKENS-->
                <v-expansion-panel class="mb-2">
                    <v-expansion-panel-header class="pa-0" style="min-height:0" hide-actions>
                        <v-toolbar class="expand-panel-header-custom" dense dark>
                            <v-app-bar-nav-icon></v-app-bar-nav-icon>

                            <v-toolbar-title>Palabras</v-toolbar-title>

                            <v-spacer></v-spacer>

                            <v-btn icon>
                                <v-icon>mdi-voice</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="filter-color pt-4">

                        <v-card class="item-card mx-auto" raised elevation="100">

                            <v-container class="filter-row-color pa-5" fluid>
                                <v-row no-gutters class="">
                                    <v-col cols="12">
                                        <v-data-table class="transparent" show-expand single-expand item-key="cod"
                                            :headers="headers" :items="tokens" :expanded.sync="expanded"
                                            @item-expanded="loadTokenDetails" @update="alert('')" locale="es-ES"
                                            :search="search_tokens" :custom-filter="searchFilter"
                                            :loading="tokens_loading" loading-text="Cargando datos..."
                                            no-data-text="No se han encontrado resultados" :footer-props="{
                                                itemsPerPageOptions: [10, 20, 30],
                                                'items-per-page-text': 'Palabras por página'
                                            }">

                                            <template v-slot:top>
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex class="row-padding" xs12>
                                                            <v-row no-gutters justify="end">
                                                                <v-col cols="auto">
                                                                    <v-text-field class="mx-4 my-3"
                                                                        style="max-width:300px" v-model="search_tokens"
                                                                        append-icon="search" label="Filtrar" dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </template>

                                            <template v-slot:item="{ item, index, expand, isExpanded }">
                                                <tr :id="'row_' + item['cod']" :key="item.cod">
                                                    <td class="text-xs-left">
                                                        <v-btn small text icon @click="expand(!isExpanded)">
                                                            <v-icon color="primary"
                                                                v-if="isExpanded">mdi-chevron-down</v-icon>
                                                            <v-icon color="orange" v-else>mdi-chevron-right</v-icon>
                                                        </v-btn>
                                                    </td>
                                                    <!--                                        <td class="text-left body-1">
                                                                                            {{item["cod"]}}
                                                                                        </td>-->
                                                    <td>
                                                        <v-text-field class="discursive-unit-content text-start"
                                                            type="string" dense hide-details
                                                            v-html="item.metadata_contents">
                                                        </v-text-field>
                                                    </td>
                                                    <td class="text-center body-1">
                                                        {{ item.duration }}
                                                    </td>
                                                </tr>
                                            </template>

                                            <template v-slot:expanded-item="{ headers, item }">
                                                <td :colspan="headers.length" style="padding:0">
                                                    <v-card v-if="item" class="filter-color" text tile>
                                                        <v-container v-if="subact" class="px-5 py-3" fluid>
                                                            <v-row no-gutters>
                                                                <v-col cols="12">
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <loading-wheel
                                                                            v-if="audio_is_loading"></loading-wheel>
                                                                        <div :id="'plyr_token_' + item['cod']">
                                                                            <audio id="audio_player">
                                                                            </audio>
                                                                        </div>
                                                                    </v-row>
                                                                    <v-row no-gutters justify="center" align="center">
                                                                        <v-btn class="ml-10" rounded dense
                                                                            :to="getItemLink('token_details', item['cod'])"
                                                                            dark>
                                                                            <!-- @click.stop="openDetailedView('token_details', -->
                                                                            item['cod'])"
                                                                            <v-icon dark>pageview</v-icon>
                                                                            <span style="text-indent: 5px">Ver
                                                                                Detalles</span>
                                                                        </v-btn>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-card>
                                                </td>
                                            </template>
                                            <template v-slot:[`footer.page-text`]="items"> {{ items.pageStart }} - {{
                                                items.pageStop }} de {{ items.itemsLength }} </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-container>
</template>
<script>
import api from '@/restApi';
import { Breadcrumb, Loading } from '@/components';

export default {
    name: 'subact-details',
    bodyClass: 'default-page',
    props: {
        code: {
            type: String,
            default() {
                return "";
            }
        }
    },
    data() {
        return {
            page: null,
            section: null,
            subsection: null,
            search_subacts: "",
            search_tokens: "",
            subact: null,
            subacts: [],
            tokens: [],
            alternate: false,
            audio_is_loading: true,
            expanded: [],
            expanded_token: [],
            subact_loading: true,
            subacts_loading: true,
            tokens_loading: true,
            player: null,
            headers: [
                //                    {
                //                        text: "Id",
                //                        align: "left",
                //                        sortable: "false",
                //                        value: "cod"
                //                    },
                {
                    text: "Contenido",
                    align: "center",
                    value: "metadata_contents"
                },
                {
                    text: "Duración",
                    align: "center",
                    value: "duration",
                    width: 100
                }
            ]
        };
    },
    created: function () {
        const params = this.$route.params;

        this.page = params.page;
        this.section = params.section;
        this.subsection = params.subsection;

        this.loadSubactData();
    },
    mounted: function () {
    },
    watch: {
    },
    methods: {
        getItemLink(view, cod) {
            const link = '/pages/' + this.page + "/" + this.section + "/" + this.subsection + "/" + view + "/" + cod;

            return link;
        },
        searchFilter(value, search, item) {
            //                console.log(value + " - " + search + " - " + item);

            return (value !== null &&
                search !== null && typeof value === 'string' &&
                this.$mout.string.contains(item.metadata_contents, search));
        },
        async loadSubactDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded)
            isExpanding = !self.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO",isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_subact_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            if (self.player) {
                self.player.destroy();
            }

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        async loadTokenDetails({ item }) {
            var elementId, conversationCode;
            var start, duration;
            var isExpanding;
            var self = this;

            self.audio_is_loading = true;

            self.alternate = !self.alternate;

            //                console.log(self.expanded)
            isExpanding = !this.$mout.array.filter(self.expanded, function (item2) {
                //                console.log(item2["cod"],"-",item["cod"])
                return item2["cod"] === item["cod"];
            }).length > 0;
            //                console.log("EOOOOOOOOOOOOOOOOOOOOO",isExpanding)

            if (this.$mout.lang.isEmpty(item) || !isExpanding) {
                return;
            }

            //                console.log("Element", "plyr_token_" + item["cod"]);
            //                console.log("Expanded item", item);

            elementId = "#audio_player";
            conversationCode = item["cod"].substring(0, item["cod"].indexOf("-"));
            start = item["start"];
            duration = item["end"] - item["start"];

            setTimeout(async function () {
                self.player = await self.loadPlayer(elementId, conversationCode, start, duration, self.audio_is_loading);

                self.audio_is_loading = false;
            }, 10);
        },
        openDetailedView(view, inputParams, modifiers) {
            this.$emit('clicked', view + (inputParams ? "/" + inputParams : "") + "/" + (modifiers ? "/" + inputParams : ""));
        },
        async loadSubactData() {
            await this.loadSubact();
            // this.loadSubacts();
            this.loadTokens();
        },
        async loadSubact() {
            var queryString;

            this.subact_loading = true;

            queryString = "cod=" + this.code + "&populate=subact_type";

            // Get the subact with given code
            const subacts = await api.get("subact", queryString);

            this.subact = subacts[0];

            //                this.subact["tokens_count"] = await api.getTokenCount(this.subact["cod"]);

            this.subact["duration"] = this.millisToMinutesAndSeconds(this.subact["end"] - this.subact["start"]);
            this.subact["start"] = this.millisToMinutesAndSeconds(this.subact["start"]);
            this.subact["end"] = this.millisToMinutesAndSeconds(this.subact["end"]);

            this.subact_loading = false;
        },
        async loadSubacts() {
            var queryString;
            var subacts;

            this.subacts_loading = true;

            queryString = "subact=" + this.subact["_id"] + "&fields=cod,metadata_contents,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all subacts
            subacts = await api.getAllItems("subact", queryString);

            for (var i in subacts) {
                subacts[i]["duration"] = this.millisToMinutesAndSeconds(subacts[i]["end"] - subacts[i]["start"]);
            }

            this.subacts = subacts;

            this.act_loading = false;
        },
        async loadTokens() {
            var queryString;
            var tokens;

            this.tokens_loading = true;

            queryString = "subact=" + this.subact["_id"] + "&fields=cod,cleaned_contents,start,end&sort={\"field\":\"order\",\"dir\":\"asc\"}";

            // Get all tokens
            tokens = await api.getAllItems("token", queryString);

            for (var i in tokens) {
                //                    if (this.$mout.lang.isEmpty(tokens[i]["metadata_contents"])) {
                tokens[i]["metadata_contents"] = tokens[i]["cleaned_contents"];
                //                    }
                tokens[i]["duration"] = this.millisToMinutesAndSeconds(tokens[i]["end"] - tokens[i]["start"]);
            }

            this.tokens = tokens;

            this.tokens_loading = false;
        }
    },
    components: {
        [Breadcrumb.name]: Breadcrumb,
        [Loading.name]: Loading
    }
};
</script>

<style>
.transparent>.table,
.transparent>.table__overflow>.table,
.transparent>.table>.datatable__actions {
    background-color: #fde19a;
}
</style>
